
import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/tokens.css";
import "./styles/index.css";
import Webapp from "./layouts/Webapp";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ErrorPage from "./components/ErrorPage";
import FootballSession from "./layouts/FootballSession";
import FootballSessionView from "./components/FootballSessionView";
import OtherSessions from "./layouts/OtherSessions";
import AnalizeSession from "./layouts/AnalizeSession";
import { ProviderContext } from "./services/Context";
import PlaysView from "./layouts/PlaysView";
import ListOfPlays from "./layouts/ListOfPlays";
import CreateAccount from "./layouts/CreateAccount";
import ManagementAccount from "./components/ManagementAccount";
import PaymentHandler from "./components/PaymentHandler";
import ProtectedRoute from "./components/ProtectedRoute";

// src/index.js
if (process.env.NODE_ENV === 'production') {
  if (typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined') {
    for (let [key, value] of Object.entries(window.__REACT_DEVTOOLS_GLOBAL_HOOK__)) {
      window.__REACT_DEVTOOLS_GLOBAL_HOOK__[key] = typeof value == "function" ? () => {} : null;
    }
  }
}
const router = createBrowserRouter([
  {
    path: "/",
    element: <Webapp />,
    errorElement: <ErrorPage />,
  },
  {
    path: "football-session",
    element: (
      <ProtectedRoute>
        <FootballSession />
      </ProtectedRoute>
    ),
  },
  {
    path: "player-view",
    element: (
      <ProtectedRoute>
        <FootballSessionView />
      </ProtectedRoute>
    ),
  },
  {
    path: "plays-view/:play",
    element: (
      <ProtectedRoute>
        <PlaysView />
      </ProtectedRoute>
    ),
  },
  { 
    path: "list-of-plays", 
    element: (
      <ProtectedRoute>
        <ListOfPlays />
      </ProtectedRoute>
    ),
  },
  {
    path: "other-sessions",
    element: (
      <ProtectedRoute>
        <OtherSessions />
      </ProtectedRoute>
    ),
  },
  {
    path: "analize-session/:session",
    element: (
      <ProtectedRoute>
        <AnalizeSession />
      </ProtectedRoute>
    ),
  },
  {
    path: "create-account",
    element: <CreateAccount />,
  },
  {
    path: "management-account",
    element: (
      <ProtectedRoute>
        <ManagementAccount />
      </ProtectedRoute>
    ),
  },
  {
    path:"payment-handler",
    element: (
      <ProtectedRoute>
        <PaymentHandler />
      </ProtectedRoute>
    ),
  }
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ProviderContext>
    <RouterProvider router={router} />
  </ProviderContext>
);
